import axios from 'axios' // 引入axios
import qs from 'qs' // 引入qs
import router from '../router'

/**
 * 为了兼容域名地址协议，访问https接口就是https开头，访问http接口就是http
 * 接口地址不用写 https 或 http
 */

// let baseURL = '//192.168.2.249:7777'; // 周


// 客户域名
// const baseURL = '//miniclo.tech';
// const uploadURL = '//miniclo.tech';

const baseURL = '//www.minikura.tech';
const uploadURL = '//www.minikura.tech';

// const baseURL = '//jpmallapi.59156.cn';

// const uploadURL = '//jpmallapi.59156.cn';

axios.defaults.baseURL = baseURL; //请求地址的域名（此处使用了代理所以直接填／apis
// 拦截响应response，进行错误处理
axios.interceptors.response.use(function (response) {
  // 成功处理
  
  // console.log('响应码：', response.data.code);
  // router.back()
  return response;
}, function (error) {
  // 失败处理 
  error.code = error.response.status
  switch (error.response.status) {
    case 400:
      error.message = '错误请求'
      break;
    case 401:
      error.message = '未授权，请重新登录'
      break;
    case 403:
      error.message = '拒绝访问'
      break;
    case 404:
      error.message = '请求错误,未找到该资源'
      break;
    case 405:
      error.message = '请求方法未允许'
      break;
    case 408:
      error.message = '请求超时'
      break;
    case 500:
      error.message = '服务器端出错'
      break;
    case 501:
      error.message = '网络未实现'
      break;
    case 502:
      error.message = '网络错误'
      break;
    case 503:
      error.message = '服务不可用'
      break;
    case 504:
      error.message = '网络超时'
      break;
    case 505:
      error.message = 'http版本不支持该请求'
      break;
    default:
      error.message = `连接错误${error.response.status}`
  }
  return Promise.reject(error);
});

// 拦截响应response，进行错误处理
axios.interceptors.request.use(function (config) {
  // 成功处理
  var token = localStorage.getItem('token');
  if(token){
    config.headers.Authorization = 'Bearer '+token;
  }

  
  // console.log(config);
  return config;
}, function (error) {
  return Promise.reject(error);
});

async function request(Uri, params, method ='post',config='',tips) {
// 这里主要是post方法的封装，get方法同理
 
  var options = {
    url: Uri,
    // config:'formData',
    headers:{},
  };
  if(config){
    options.config = config;
  }
  //获取当前语言
  var languageList=['','ja_JP','en_US','','zh_TW'];
  var lang = localStorage.getItem("lang") || 3;
  if(params.lang){
    lang = params.lang;
    if(lang == 3){
      params.lang ='';
    }
  }
  
  if(lang != 3){
    params.lang = languageList[lang];
  }
  var noLangUrl = [
    '/merchant/category/add',
    '/merchant/category/edit',
    '/merchant/delivery/add',
    '/merchant/delivery/edit',
    '/merchant/category/list',
    '/merchant/delivery/list',
    '/merchant/entrance/edit',
    // '/merchant/entrance/info',
    // '/merchant/entrance/listAll',
    '/merchant/entrance/add',


  ];
  if(noLangUrl.indexOf(options.url) > -1){
    params.lang = '';
  }
  
  options.method =method;
  if(method=='post' || method == 'put' || method == 'delete'){
    options.data = params;
  }else{
    options.params = params;
  }
  if (options.config === 'formData') {
     
  } else {
    if(method=='post'){
      // console.log(options.url);
      var nostr=[
        '/api/app/merchant/apply'
        ,'/merchant/category/list'
        ,'/merchant/category/add'
        ,'/merchant/category/edit'
        ,'/platform/market/list'
        ,'/merchant/push/list'
        ,'/merchant/afterSale/'
        ,'/merchant/banner/list'
        ,'/merchant/banner/add'
        ,'/merchant/store/push/add'
        ,'/merchant/category/remove'
        ,'/merchant/store/push/remove'
        ,'/merchant/category/transfer'
        ,'/merchant/store/edit'
        ,'/merchant/edit'
        ,'/merchant/store/add'
        ,'/merchant/role'
        ,'/merchant/user'
        ,'/merchant/user/updEmail'
        ,'/merchant/user/resetPwd'
        ,'/merchant/logistics/edit'
        ,'/merchant/store/editBackground'
        ,'/merchant/store/editBusiness'
        ,'/merchant/applyThaw'
        ,'/merchant/push/edit'
        ,'/merchant/content/record/add'
        ,'/merchant/store/closeShop'
        ,'/merchant/store/applyThaw'
        // ,'/merchant/helpType/list'     
        ,'/merchant/handle'
        ,'merchant/banner/bannerOrderDate'
        // ,'/merchant/flowwater/list'
        ,'/merchant/banner/export'
        ,'/merchant/logistics/export'
        ,'/merchant/comment/export'
        ,'/merchant/appeal/export'
        ,'/merchant/afterSale/export'
        ,'/merchant/goods/export'
        ,'/merchant/handle/export'
        ,'merchant/push/confirm'
        ,'/api/app/banner/list'
        ,'//merchant/settlement/record/export'
        ,'/merchant/entrance/add'
        ,'/merchant/entrance/edit'
        ,'/merchant/editPayment'
        ,'/merchant/delivery/add'
        ,'/merchant/delivery/edit'
        ,'/merchant/banner/edit'
        ,'merchant/store/editPaymentConfirm'
        ,'merchant/flowwater/info'
        ,'merchant/stock/info'
      ];
      if(nostr.indexOf(options.url) == -1){
        options.data = qs.stringify(options.data);
      }
    }else{

    }
  }
  var jsonheader = [
    '/api/app/merchant/apply'
    ,'/merchant/category/list'
    ,'/merchant/category/add'
    ,'/merchant/category/edit'
    ,'/platform/market/list'
    ,'/merchant/push/list'
    ,'/merchant/afterSale/'
    ,'/merchant/banner/list'
    ,'/merchant/banner/add'
    ,'/merchant/store/push/add'
    ,'/merchant/category/remove'
    ,'/merchant/store/push/remove'
    ,'/merchant/category/transfer'
    ,'/merchant/store/edit'
    ,'/merchant/edit'
    ,'/merchant/store/add'
    ,'/merchant/role'
    ,'/merchant/user'
    ,'/merchant/user/updEmail'
    ,'/merchant/user/resetPwd'
    ,'/merchant/logistics/edit'
    ,'/merchant/store/editBackground'
    ,'/merchant/store/editBusiness'
    ,'/merchant/applyThaw'
    ,'/merchant/push/edit'
    ,'/merchant/content/record/add'
    ,'/merchant/store/closeShop'
    ,'/merchant/store/applyThaw'
    // ,'/merchant/helpType/list'
    ,'/merchant/handle'
    ,'merchant/banner/bannerOrderDate'
    // ,'/merchant/flowwater/list'
    ,'/merchant/banner/export'
    ,'/merchant/logistics/export'
    ,'/merchant/comment/export'
    ,'/merchant/appeal/export'
    ,'/merchant/afterSale/export'
    ,'/merchant/goods/export'
    ,'/merchant/handle/export'
    ,'merchant/push/confirm'
    ,'/api/app/banner/list'
    ,'/merchant/settlement/record/export'
    ,'/merchant/entrance/add'
    ,'/merchant/entrance/edit'
    ,'/merchant/editPayment'
    ,'/merchant/delivery/add'
    ,'/merchant/delivery/edit'
    ,'/merchant/delivery/edit'
    ,'merchant/flowwater/info'
    ,'merchant/stock/info'
];
  if(jsonheader.indexOf(options.url) > -1){
    options.headers['Content-Type'] = 'application/json;charset=UTF-8';
  }
  // console.log(options);
  return new Promise((resolve, reject) => {
    axios(options).then(res => {
      //  这里主要根据后来返回的数据作判断，请根据实际情况
      if (res.status === 200) {

        if(res.data.code == 401){
          //未登录
          let that = this;
          localStorage.removeItem('token');
          this.$message({
            message: this.$t('errorMsg.loginOut'),
            type: "error",
            onClose: function () {
              location.href = '/';
            },
        });
        }else {
          resolve(res.data)
        }
      } else {
        console.log(`status: ${res.data.status}, message: ${ res.data.message }`);
        // this.$message.error(`status: ${res.data.status}, message: ${ res.data.message }`)
        reject(res.data)
      }
    }).catch(error => {
      console.log(error);
      // 显示拦截器对respone处理后的可读错误
      console.log(`${error.code} : ${ error.message }`)
      // this.$message.error(`${error.code} : ${ error.message }`)
    })
  })
}

export default { request, baseURL,uploadURL}

//安装axios
//npm i axios

//安装qs
// npm i qs

//main.js
// import Request from '@/utils/request' // 引入封装的文件
// const { request } = Request
// Vue.prototype.$http = request // 挂载到全局上

//使用方法
/*

mounted () {
  that.$http('/app/index/index', {}).then(res =>{
    console.log(res);

  });
}

*/




// WEBPACK FOOTER //
// ./src/api/request.js